import { inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { getAuthenticatedStatus } from '@app/reducers/auth/auth-service.selectors';
import { Store } from '@ngrx/store';
import { AppState } from '@reducers/interfaces';
import { Observable, of } from 'rxjs';
import { switchMap } from 'rxjs/operators';

@Injectable()
export class PausedGuard {
  private store = inject<Store<AppState>>(Store);
  private router = inject(Router);

  canActivate(): Observable<boolean> | boolean {
    return this.store.select(getAuthenticatedStatus).pipe(
      switchMap((authStatus) => {
        if (authStatus === 'paused') {
          return of(true);
        } else {
          this.router.navigate(['/dashboard']);
          return of(false);
        }
      }),
    );
  }
}
